import { AirplayTwoTone } from '@material-ui/icons';
import { GET_USER_PROFILE, SET_SELECTED_USER_CENTRO_PROFILE } from '../constants/action_types';
import { GetKDfromString } from '../KDgeneric'

const initialState = { profile: {}, selectedCentroProfile: undefined };

export default function (state = initialState, action) {


    switch (action.type) {

        case SET_SELECTED_USER_CENTRO_PROFILE:

            return { ...state, selectedCentroProfile: state.profile.usuarioCentro[action.payload] };

        case GET_USER_PROFILE + "_SUCCESS":

            //seleccionamos el centro por defecto del usuario de entre los centros activos
            let selected = action.payload.data.usuarioCentro.filter(uc => uc.centro.activo === 1 && uc.centroId === action.payload.data.centroId)[0];
            // si no esta activo el centro sleccionamos el primero de los activos
            if (selected === undefined) selected = action.payload.data.usuarioCentro.filter(uc => uc.centro.activo === 1)[0];

            // fbp_kd
            if (action.meta.kd === undefined) {
                return { profile: action.payload.data, selectedCentroProfile: selected };
            }
            else {
                let kds = GetKDfromString(action.meta.kd);
                if (kds.centro_id === -1)
                    return { profile: action.payload.data, selectedCentroProfile: selected };
                else {
                    if (selected === undefined)
                        return { profile: action.payload.data, selectedCentroProfile: selected };
                    else
                        return { profile: action.payload.data, selectedCentroProfile: selected, kd: kds };
                }
            }

        default:

            return state;
    }
}